import React from 'react';
import { Container, Box, useColorModeValue } from '@chakra-ui/react';
import MintingForm from '../components/MintingForm';
import ConnectWallet from '../components/ConnectWallet';
import { useWeb3 } from '../lib/Web3Provider';

const MintPage: React.FC = () => {
  const { connected } = useWeb3();
  const bgColor = useColorModeValue("white", "gray.800");

  if (!connected) {
    return <ConnectWallet />;
  }

  return (
    <Container maxW="container.lg" py={8}>
      <Box 
        bg={bgColor}
        p={8} 
        borderRadius="lg" 
        boxShadow="md"
      >
        <MintingForm />
      </Box>
    </Container>
  );
};

export default MintPage;